<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div class="row pl-4 pr-4" v-show="tela == 1">
            <h4 slot="header" class="card-title text-left m-0">
              RELATÓRIO DE PONTO PELO CELULAR
            </h4>
            <BaseFiltroRelatorio
              class="col-sm-6 col-12"
              @pesquisar="pesquisar"
              :btEnviarEmail="false"
              :isMessage="false"
            />
            <div class="offset-sm-6 "></div>
          </div>
          <p class="text-danger small mt-2">
            Se mais de um mês for selecionado, a opção "Todos" será desativada.
          </p>

          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>

            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      {{ `RELATÓRIO DE PONTO PELO CELULAR` }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à
                                            ${moment(
                                              payloadPesquisa.data_final,
                                            ).format("DD/MM/YYYY")}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `DEPARTAMENTO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `POSTO DE TRABALHO: NENHUM` }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--Tabela de Resultados-->

            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Data</th>
                    <th scope="col" style="min-width: 250px;">Nome</th>
                    <th scope="col">ENT1</th>
                    <th scope="col">Local</th>
                    <th scope="col">SAÍ1</th>
                    <th scope="col">Local</th>
                    <th scope="col">ENT2</th>
                    <th scope="col">Local</th>
                    <th scope="col">SAÍ2</th>
                    <th scope="col">Local</th>
                    <th scope="col">ENT3</th>
                    <th scope="col">Local</th>
                    <th scope="col">SAÍ3</th>
                    <th scope="col">Local</th>
                    <th scope="col">ENT4</th>
                    <th scope="col">Local</th>
                    <th scope="col">SAÍ4</th>
                    <th scope="col">Local</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in tableData" :key="item.key">
                    <td>{{ item.data }}</td>
                    <td>{{ item.nome }}</td>
                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida1)"
                        @click="
                          handleOpenLocation(item.latitude1, item.longitude1)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso1,
                              item.offline1,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso1,
                              item.offline1,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora1, item.tipo_batida1)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida1)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio1 || null),
                        }"
                      >
                        {{ item.local1 }}
                      </p>
                    </td>

                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida2)"
                        @click="
                          handleOpenLocation(item.latitude2, item.longitude2)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso2,
                              item.offline2,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso2,
                              item.offline2,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora2, item.tipo_batida2)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida2)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio2 || null),
                        }"
                      >
                        {{ item.local2 }}
                      </p>
                    </td>

                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida3)"
                        @click="
                          handleOpenLocation(item.latitude3, item.longitude3)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso3,
                              item.offline3,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso3,
                              item.offline3,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora3, item.tipo_batida3)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida3)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio3 || null),
                        }"
                      >
                        {{ item.local3 }}
                      </p>
                    </td>

                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida4)"
                        @click="
                          handleOpenLocation(item.latitude4, item.longitude4)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso4,
                              item.offline4,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso4,
                              item.offline4,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora4, item.tipo_batida4)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida4)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio4 || null),
                        }"
                      >
                        {{ item.local4 }}
                      </p>
                    </td>

                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida5)"
                        @click="
                          handleOpenLocation(item.latitude5, item.longitude5)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso5,
                              item.offline5,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso5,
                              item.offline5,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora5, item.tipo_batida5)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida5)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio5 || null),
                        }"
                      >
                        {{ item.local5 }}
                      </p>
                    </td>

                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida6)"
                        @click="
                          handleOpenLocation(item.latitude6, item.longitude6)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso6,
                              item.offline6,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso6,
                              item.offline6,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora6, item.tipo_batida6)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida6)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio6 || null),
                        }"
                      >
                        {{ item.local6 }}
                      </p>
                    </td>

                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida7)"
                        @click="
                          handleOpenLocation(item.latitude7, item.longitude7)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso7,
                              item.offline7,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso7,
                              item.offline7,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora7, item.tipo_batida7)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida7)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio7 || null),
                        }"
                      >
                        {{ item.local7 }}
                      </p>
                    </td>

                    <td>
                      <a
                        style="cursor: pointer;"
                        class="btn-link"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="pegarTextoTooltip(item.tipo_batida8)"
                        @click="
                          handleOpenLocation(item.latitude8, item.longitude8)
                        "
                      >
                        <div
                          v-html="
                            pegarOffOnlineIcon(
                              item.enderecoPorExtenso8,
                              item.offline8,
                            )
                          "
                        ></div>
                        <div
                          v-show="printing"
                          v-html="
                            pegarOffOnlineTextoImpressao(
                              item.enderecoPorExtenso8,
                              item.offline8,
                            )
                          "
                        ></div>
                        <div
                          v-html="pegarTextoHora(item.hora8, item.tipo_batida8)"
                        ></div>
                        <div v-html="pegarIcon(item.tipo_batida8)"></div>
                      </a>
                    </td>

                    <td>
                      <p
                        :style="{
                          color: corTextoLocal(item.dentroDoRaio8 || null),
                        }"
                      >
                        {{ item.local8 }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--PaginacaoComQuantidade-->
            <PaginacaoComQuantidade
              v-if="tableData.length > 0"
              :currentPage="pagination.currentPage"
              :totalItems="pagination.totalItems"
              :rowsPerPage="pagination.perPage"
              :rowsPerPageOptions="
                exibirTodos ? [100, 200, 400, -1] : [100, 200, 400]
              "
              @page-changed="carregarRelatorio"
              @rows-per-page-changed="atualizarItensPorPagina"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BaseFiltroRelatorio,
  PaginacaoComQuantidade,
} from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseFiltroRelatorio,
    PaginacaoComQuantidade,
  },
  computed: {},
  data() {
    return {
      payloadPesquisa: Object,
      tela: 1,
      printing: false,
      isLoading: false,
      dados: Array,
      tableData: [],
      exibirTodos: true,
      pagination: {
        currentPage: 1,
        perPage: 100, // Quantidade inicial de itens por página
        totalItems: 0, // Total de registros
        totalPages: 0,
      },
    };
  },
  mounted() {},
  methods: {
    corTextoLocal(dentroDoRaio) {
      if (Number(dentroDoRaio) === 0) return "red";
      if (Number(dentroDoRaio) === 1) return "#35a887";
      if (Number(dentroDoRaio) === 2) return "orange";
      return "#64779e"; // Cor padrão, se necessário
    },
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    pegarTextoTooltip(tipo_batida) {
      if (tipo_batida == 1 || tipo_batida == 2) {
        return "Abrir no mapa";
      }
      if (tipo_batida == 3) {
        return "Registro pelo RH";
      }
      if (tipo_batida == 5) {
        return "Registro Biométrico Digital";
      }

      return "";
    },
    pegarOffOnlineIcon(detalhe, offline) {
      if (
        detalhe == "batidaOnline" ||
        detalhe == "batidaOffline" ||
        offline == 0 ||
        offline == 1
      ) {
        let color = "green";
        if (detalhe == "batidaOffline" || offline) {
          color = "red";
        }
        return `<div><i class="fas fa-signal" style="color: ${color};"></i></div>`;
      }
      return "";
    },
    pegarOffOnlineTextoImpressao(detalhe, offline) {
      if (
        detalhe == "batidaOnline" ||
        detalhe == "batidaOffline" ||
        offline == 0 ||
        offline == 1
      ) {
        let text = `<strong style="font-size:12px">ONLINE</strong>`;
        if (detalhe == "batidaOffline" || offline) {
          text = `<strong style="font-size:12px" >OFFLINE</strong>`;
        }
        return text;
      }
      return "";
    },
    pegarTextoHora(hora, tipo_batida) {
      if (tipo_batida == 1 || tipo_batida == 2) {
        return `<span style="color: #64779e">${hora}</span>`;
      }
      if (tipo_batida == 5) {
        return `<span style="color: #334e87">${hora}</span>`;
      }
      if (tipo_batida == 3) {
        return `${hora}*`;
      }

      return `${hora}`;
    },
    pegarIcon(tipo_batida) {
      if (tipo_batida == 1 || tipo_batida == 2) {
        return `<i class="tim-icons icon-pin"></i>`;
      }
      return "";
    },
    pegarLabels(movimentacao) {
      const hora = movimentacao ? `${movimentacao.hora}` : "-";
      const local = movimentacao ? `${movimentacao.local}` : "-";
      const latitude = movimentacao ? movimentacao.latitude : undefined;
      const longitude = movimentacao ? movimentacao.longitude : undefined;
      const tipo_batida = movimentacao ? movimentacao.tipoBatida : undefined;
      return { hora, local, latitude, longitude, tipo_batida, ...movimentacao };
    },
    handleOpenLocation(latitude, longitude) {
      if (!latitude || !longitude) return;
      window.open(
        `https://www.google.com/maps/search/${latitude},${longitude}/@${latitude},${longitude},21z`,
        "_blank",
      );
    },

    handleRowsPerPageChange() {
      if (this.previousRowsPerPage !== this.rowsPerPage) {
        this.$emit("rows-per-page-changed", this.rowsPerPage);
        this.previousRowsPerPage = this.rowsPerPage;
      }
    },
    handlePageChange(newPage) {
      if (this.currentPage !== newPage) {
        this.$emit("page-changed", newPage);
      }
    },

    atualizarItensPorPagina(itemsPerPage) {
      if (this.pagination.perPage === itemsPerPage) return; // Evita reações desnecessárias
      this.pagination.perPage = itemsPerPage;
      this.pagination.currentPage = 1; // Reinicia na primeira página
      this.carregarRelatorio(); // Chamada única do relatório
    },

    temMaisDeUmMes(data_inicial, data_final) {
      const inicio = new Date(data_inicial);
      const final = new Date(data_final);
      this.isLoading = false;

      if (final.getFullYear() > inicio.getFullYear()) {
        this.exibirTodos = false;
        return;
      }

      if (final.getFullYear() === inicio.getFullYear()) {
        const mesDiferenca = final.getMonth() - inicio.getMonth();
        const diaDiferenca = final.getDate() - inicio.getDate();

        if (mesDiferenca > 0 || (mesDiferenca === 0 && diaDiferenca >= 30)) {
          this.exibirTodos = false;
        } else {
          this.exibirTodos = true;
        }
        return;
      }

      this.exibirTodos = true;
    },

    async carregarRelatorio(page = 1, enviarEmail = false) {
      let th = this;
      if (this.isLoading) return; // Evita múltiplas chamadas simultâneas
      this.isLoading = true;

      const payload = {
        ...this.payloadPesquisa,
        page,
        limit:
          this.pagination.perPage === -1
            ? this.pagination.totalItems
            : this.pagination.perPage,
      };
      this.axios
        .post(
          `/api/relatorio/relatorioMovimentacoesCelular${
            enviarEmail ? "" : "2"
          }`,
          payload,
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        )
        .then((response) => {
          if (response.data.status) {
            if (enviarEmail) {
              setTimeout(() => {
                location.reload();
              }, 3000);
            } else {
              this.pagination = {
                ...this.pagination,
                totalItems: response.data.data.pagination.totalItems,
                totalPages: Math.ceil(
                  response.data.data.pagination.totalItems /
                    this.pagination.perPage,
                ),
              };
              const movimentacoes = response.data.data.dados;
              const movimentacoesFormatada = [];
              movimentacoes.forEach((movimentacao) => {
                const batidas = movimentacao.movimentacoes;
                const {
                  hora: hora1,
                  local: local1,
                  latitude: latitude1,
                  longitude: longitude1,
                  dentroDoRaio: dentroDoRaio1,
                  tipo_batida: tipo_batida1,
                  enderecoPorExtenso: enderecoPorExtenso1,
                  offline: offline1,
                } = this.pegarLabels(batidas[0]);
                const {
                  hora: hora2,
                  local: local2,
                  latitude: latitude2,
                  longitude: longitude2,
                  dentroDoRaio: dentroDoRaio2,
                  tipo_batida: tipo_batida2,
                  enderecoPorExtenso: enderecoPorExtenso2,
                  offline: offline2,
                } = this.pegarLabels(batidas[1]);
                const {
                  hora: hora3,
                  local: local3,
                  latitude: latitude3,
                  longitude: longitude3,
                  dentroDoRaio: dentroDoRaio3,
                  tipo_batida: tipo_batida3,
                  enderecoPorExtenso: enderecoPorExtenso3,
                  offline: offline3,
                } = this.pegarLabels(batidas[2]);
                const {
                  hora: hora4,
                  local: local4,
                  latitude: latitude4,
                  longitude: longitude4,
                  dentroDoRaio: dentroDoRaio4,
                  tipo_batida: tipo_batida4,
                  enderecoPorExtenso: enderecoPorExtenso4,
                  offline: offline4,
                } = this.pegarLabels(batidas[3]);
                const {
                  hora: hora5,
                  local: local5,
                  latitude: latitude5,
                  longitude: longitude5,
                  dentroDoRaio: dentroDoRaio5,
                  tipo_batida: tipo_batida5,
                  enderecoPorExtenso: enderecoPorExtenso5,
                  offline: offline5,
                } = this.pegarLabels(batidas[4]);
                const {
                  hora: hora6,
                  local: local6,
                  latitude: latitude6,
                  longitude: longitude6,
                  dentroDoRaio: dentroDoRaio6,
                  tipo_batida: tipo_batida6,
                  enderecoPorExtenso: enderecoPorExtenso6,
                  offline: offline6,
                } = this.pegarLabels(batidas[5]);
                const {
                  hora: hora7,
                  local: local7,
                  latitude: latitude7,
                  longitude: longitude7,
                  dentroDoRaio: dentroDoRaio7,
                  tipo_batida: tipo_batida7,
                  enderecoPorExtenso: enderecoPorExtenso7,
                  offline: offline7,
                } = this.pegarLabels(batidas[6]);
                const {
                  hora: hora8,
                  local: local8,
                  latitude: latitude8,
                  longitude: longitude8,
                  dentroDoRaio: dentroDoRaio8,
                  tipo_batida: tipo_batida8,
                  enderecoPorExtenso: enderecoPorExtenso8,
                  offline: offline8,
                } = this.pegarLabels(batidas[7]);
                movimentacoesFormatada.push({
                  nome: movimentacao.nome,
                  data: movimentacao.data,
                  hora1,
                  local1,
                  dentroDoRaio1,
                  hora2,
                  local2,
                  dentroDoRaio2,
                  hora3,
                  local3,
                  dentroDoRaio3,
                  hora4,
                  local4,
                  dentroDoRaio4,
                  hora5,
                  local5,
                  dentroDoRaio5,
                  hora6,
                  local6,
                  dentroDoRaio6,
                  hora7,
                  local7,
                  dentroDoRaio7,
                  hora8,
                  local8,
                  latitude1,
                  longitude1,
                  latitude2,
                  longitude2,
                  latitude3,
                  longitude3,
                  latitude4,
                  longitude4,
                  latitude5,
                  longitude5,
                  latitude6,
                  longitude6,
                  latitude7,
                  longitude7,
                  latitude8,
                  longitude8,
                  tipo_batida1,
                  tipo_batida2,
                  tipo_batida3,
                  tipo_batida4,
                  tipo_batida5,
                  tipo_batida6,
                  tipo_batida7,
                  tipo_batida8,
                  enderecoPorExtenso1,
                  enderecoPorExtenso2,
                  enderecoPorExtenso3,
                  enderecoPorExtenso4,
                  enderecoPorExtenso5,
                  enderecoPorExtenso6,
                  enderecoPorExtenso7,
                  enderecoPorExtenso8,
                  offline1,
                  offline2,
                  offline3,
                  offline4,
                  offline5,
                  offline6,
                  offline7,
                  offline8,
                });
              });

              this.tela = 2;
              this.tableData = movimentacoesFormatada;
            }
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar relatório!",
              "error",
            );
          }
          this.temMaisDeUmMes(
            this.payloadPesquisa.data_inicial,
            this.payloadPesquisa.data_final,
          );
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar relatório!",
            "error",
          );
        });
    },

    enviarEmail(event) {
      this.carregarRelatorio(event, true);
    },
    pesquisar(event) {
      this.payloadPesquisa = event;
      this.carregarRelatorio(1);
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
  },
  watch: {},
};
</script>
<style></style>
